"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var convertToArray = function convertToArray(value) {
  if ((0, _isNil2["default"])(value) || (0, _isArray2["default"])(value)) {
    return value;
  }

  return [value];
};

var _default = convertToArray;
exports["default"] = _default;